// extracted by mini-css-extract-plugin
export var addPaddingStyle = "rsc_hb_card_inner-module--addPaddingStyle---jlSZ";
export var fullWidthStyle = "rsc_hb_card_inner-module--fullWidthStyle--awVZ8";
export var headingWrapperStyle = "rsc_hb_card_inner-module--headingWrapperStyle--ClsT-";
export var innerStyle = "rsc_hb_card_inner-module--innerStyle--cCM-e";
export var textStyle = "rsc_hb_card_inner-module--textStyle--gimru";